/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2556
 */

var r = require(/* 2557 */"./2557")
var i = require(/* 1172 */"../2554/1172")
var o = require(/* 1173 */"../2554/1173")
var a = o && o.isSet
var s = a ? i(a) : r
module.exports = s
